import "core-js/modules/es6.regexp.split";
import _objectSpread from "D:/androidcode/zf_tms_vue/tms_vue/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
export default {
  name: 'el-tree-select',
  props: {
    // 配置项
    props: {
      type: Object,
      default: function _default() {
        return {
          value: 'id',
          // ID字段名
          label: 'fullName',
          // 显示名称
          children: 'children' // 子级字段名
        };
      }
    },
    // 是否禁用
    disabled: {
      type: Boolean,
      default: false
    },
    // 选项列表数据(树形结构的对象数组)
    options: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    placeholder: {
      type: String,
      default: '请选择'
    },
    // 初始值
    value: '',
    // 可清空选项
    clearable: {
      type: Boolean,
      default: false
    },
    // 能否搜索
    filterable: {
      type: Boolean,
      default: false
    },
    // 只能选择最后一层的数值
    lastLevel: {
      type: Boolean,
      default: false
    },
    // 只能选择最后一层的数值时，需要根据 lastLevelKey来判断是否最后一层
    lastLevelKey: {
      type: String,
      default: 'hasChildren'
    },
    lastLevelValue: {
      default: false
    },
    // 自动收起
    accordion: {
      type: Boolean,
      default: false
    },
    defaultExpandAll: {
      type: Boolean,
      default: true
    },
    multiple: {
      type: Boolean,
      default: false
    } // 是否多选，默认单选
  },
  computed: _objectSpread({}, mapState({
    themeClass: function themeClass(state) {
      return state.settings.themeClass;
    }
  })),
  data: function data() {
    return {
      valueTitle: '',
      defaultExpandedKey: []
    };
  },
  mounted: function mounted() {
    if (this.value) {
      this.initHandle();
    }
  },
  methods: {
    selectFilter: function selectFilter(val) {
      if (this.options.length) this.$refs.selectTree.filter(val);
    },
    filterNode: function filterNode(value, data) {
      if (!value) return true;
      return data[this.props.label].indexOf(value) !== -1;
    },
    selectFocus: function selectFocus() {
      this.initHandle();
    },
    // 初始化值
    initHandle: function initHandle() {
      var _this = this;
      this.$refs.selectTree.filter('');
      if (this.value) {
        if (this.multiple) {
          setTimeout(function () {
            var arr = _this.value.split(',');
            var titleList = [];
            _this.$refs.selectTree.setCheckedKeys(arr);
            if (_this.lastLevel) {
              titleList = _this.$refs.selectTree.getCheckedNodes(true).map(function (o) {
                return o[_this.props.label];
              });
            } else {
              titleList = _this.$refs.selectTree.getCheckedNodes().map(function (o) {
                return o[_this.props.label];
              });
            }
            _this.valueTitle = titleList.join(',');
          }, 10);
        } else {
          setTimeout(function () {
            _this.valueTitle = _this.$refs.selectTree.getNode(_this.value) ? _this.$refs.selectTree.getNode(_this.value).data[_this.props.label] : ''; // 初始化显示
            _this.$refs.selectTree.setCurrentKey(_this.value); // 设置默认选中
            _this.defaultExpandedKey = [_this.value]; // 设置默认展开
          }, 10);
        }
      } else {
        this.valueTitle = '';
        if (this.multiple) {
          this.$refs.selectTree.setCheckedKeys([]);
        } else {
          this.$refs.selectTree.setCurrentKey(null);
        }
      }
      this.initScroll();
    },
    // 初始化滚动条
    initScroll: function initScroll() {
      this.$nextTick(function () {
        var list = document.querySelectorAll('.Weforsys-select-tree .el-scrollbar .el-select-dropdown__wrap');
        // 有多个下拉框，造成页面错位
        var index = list.length - 1;
        var scrollWrap = list[index];
        var scrollBar = document.querySelectorAll('.el-scrollbar .el-scrollbar__bar');
        scrollWrap.style && (scrollWrap.style.cssText = 'margin: 0px; max-height: none; overflow: hidden;');
        for (var i = 0; i < scrollBar.length; i++) {
          scrollBar[i].style.width = 0;
        }
      });
    },
    // 单选切换选项
    handleNodeClick: function handleNodeClick(node) {
      if (!this.multiple) {
        if (this.lastLevel && node[this.lastLevelKey] && node[this.lastLevelKey] != this.lastLevelValue) {
          return;
        }
        this.valueTitle = node[this.props.label];
        this.$emit('input', node[this.props.value], node);
        this.$emit('change', node[this.props.value], node);
        this.defaultExpandedKey = [];
        this.$refs.elSelect.blur();
      }
    },
    // 多选选择
    check: function check(node) {
      if (!this.multiple) return;
      var selectedData = [];
      var titleList = [];
      var selectedTextData = [];
      if (this.lastLevel) {
        selectedTextData = this.$refs.selectTree.getCheckedNodes(true);
        for (var i = 0; i < selectedTextData.length; i++) {
          var e = selectedTextData[i];
          if (e[this.lastLevelKey] == this.lastLevelValue) {
            selectedData.push(e[this.props.value]);
            titleList.push(e[this.props.label]);
          }
        }
      } else {
        selectedTextData = this.$refs.selectTree.getCheckedNodes();
        for (var _i = 0; _i < selectedTextData.length; _i++) {
          var _e = selectedTextData[_i];
          selectedData.push(_e[this.props.value]);
          titleList.push(_e[this.props.label]);
        }
      }
      this.valueTitle = titleList.join(',');
      this.$emit('input', selectedData.join(','), selectedTextData);
      this.$emit('change', selectedData.join(','), selectedTextData);
    },
    // 清除选中
    clearHandle: function clearHandle() {
      this.valueTitle = '';
      this.$emit('input', '');
      this.$emit('change', '');
      this.defaultExpandedKey = [];
      this.clearSelected();
      if (this.multiple) this.$refs.selectTree.setCheckedKeys([]);
    },
    // 清空选中样式
    clearSelected: function clearSelected() {
      var allNode = document.querySelectorAll('#tree-option .el-tree-node');
      for (var i = 0; i < allNode.length; i++) {
        allNode[i].classList.remove('is-current');
      }
    }
  },
  watch: {
    value: function value(val) {
      this.initHandle();
    },
    options: function options(val) {
      if (this.value) this.initHandle();
    }
  }
};